module.exports = {"TXTWCL_ADM_ID":{"id":"TXTWCL_ADM_ID","defaultMessage":"ADM-væddemåls-ID"}}